import { render, staticRenderFns } from "./individual_analysis_report.vue?vue&type=template&id=2024af28&scoped=true"
import script from "./individual_analysis_report.vue?vue&type=script&lang=js"
export * from "./individual_analysis_report.vue?vue&type=script&lang=js"
import style0 from "./individual_analysis_report.vue?vue&type=style&index=0&id=2024af28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2024af28",
  null
  
)

export default component.exports